// Creates a definition list (<dl>) from props
// props in the format of:
// props.definitions = {
//      "Term 1": "Definition 1",
//      "Term 2": "Definition 2",
//      "Term 3": ["Definition 3a", "Definition 3b"],
//      "Term 4": 4
// }

import React from 'react';
import PropTypes from 'prop-types';
const isArray = require('lodash/isArray');
const isNull = require('lodash/isNull');
const isObject = require('lodash/isObject');

const StringUtil = require('../../../../app/shared/StringUtil');

const propTypes = {
    definitions: PropTypes.object,
    className: PropTypes.string
};

const defaultProps = {
    definitions: {},
    className: ''
};

class DefinitionListMapped extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const terms = Object.keys(this.props.definitions);
        return (
            <dl className={this.props.className}>
                {terms.length === 0 && <dd></dd>}
                {terms.map(term => createDefinitionFragment(term, this.props.definitions[term]))}
            </dl>
        );
    }
}

function createDefinitionFragment(term, definition, newLine=false) {
    return (
        <React.Fragment key={term}>
            <dt className={newLine ? 'newLine' : ''}>{term}</dt>
            {createDefinitionValueFragments(definition)}
        </React.Fragment>
    );
}

function createDefinitionValueFragments(definition) {
    if (isArray(definition)) {
        return definition.map((def, i) => {
            return createDefinitionFragment(i, def, true);
        });
    }
    else if (isNull(definition)) {
        return <dd>null</dd>;
    }
    else if (typeof definition === 'undefined') {
        return <dd>undefined</dd>;
    }
    else if (typeof definition === 'boolean') {
        return <dd>{StringUtil.formatBool(definition)}</dd>;
    }
    else if (typeof definition === 'object') {
        return <dd><DefinitionListMapped className="margin-left-md" definitions={definition} /></dd>;
    }

    return <dd>{definition}</dd>;
}

DefinitionListMapped.propTypes = propTypes;
DefinitionListMapped.defaultProps = defaultProps;

export default DefinitionListMapped;